import React, { useEffect } from "react";
import "./Helped_Build.css";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

import { useDispatch, useSelector } from "react-redux";
import { AllBuildCareer } from "../../../features/admin/common/Slice";
import { IDS } from "../../../utils/IDS";

const Helped_Build = () => {
  // const testimonialData = [
  //   {
  //     id: 1,
  //     name: "Sonu Buradkar",
  //     role: "Software Engineer II",
  //     companyLogo: "/assets/images/pst_it_solution/Helped_Build/amazon.png",
  //     image: "/assets/images/pst_it_solution/Helped_Build/girl-img.png",
  //     content:
  //       "The DSA classes and mentorship were the best part. Regular sessions improved my problem-solving & System Design skills. A great upskilling experience overall.",
  //   },
  //   {
  //     id: 2,
  //     name: "Sonu Buradkar",
  //     role: "Software Engineer II",
  //     companyLogo: "/assets/images/pst_it_solution/Helped_Build/amazon.png",
  //     image: "/assets/images/pst_it_solution/Helped_Build/girl-img.png",
  //     content:
  //       "The DSA classes and mentorship were the best part. Regular sessions improved my problem-solving & System Design skills. A great upskilling experience overall.",
  //   },
  //   {
  //     id: 3,
  //     name: "Sonu Buradkar",
  //     role: "Software Engineer II",
  //     companyLogo: "/assets/images/pst_it_solution/Helped_Build/amazon.png",
  //     image: "/assets/images/pst_it_solution/Helped_Build/girl-img.png",
  //     content:
  //       "The DSA classes and mentorship were the best part. Regular sessions improved my problem-solving & System Design skills. A great upskilling experience overall.",
  //   },
  //   {
  //     id: 4,
  //     name: "Sonu Buradkar",
  //     role: "Software Engineer II",
  //     companyLogo: "/assets/images/pst_it_solution/Helped_Build/amazon.png",
  //     image: "/assets/images/pst_it_solution/Helped_Build/girl-img.png",
  //     content:
  //       "The DSA classes and mentorship were the best part. Regular sessions improved my problem-solving & System Design skills. A great upskilling experience overall.",
  //   },
  // ];

  const dispatch = useDispatch();
  const build_career = useSelector((state) => state.common.all_build_career);

  useEffect(() => {
    dispatch(AllBuildCareer());
  }, [dispatch]);
  return (
    <section className="Helped_Build">
      <div className="container">
        <div className="Helped_Build_header">
          <h5 className="title">PST has already helped build </h5>
          <h5 className="subtitle">5000+ Careers</h5>
        </div>

        <div className="testimonial_section">
          <Swiper
            slidesPerView={3}
            spaceBetween={30}
            // pagination={{ clickable: true }}
            modules={[Pagination, Autoplay]}
            autoplay={{
              delay: 3000,
              disableOnInteraction: false,
            }}
            loop
            breakpoints={{
              0: { slidesPerView: 1 },
              320: { slidesPerView: 1 },
              575: { slidesPerView: 1.5 },
              768: { slidesPerView: 2 },
              992: { slidesPerView: 2.2 },
              1200: { slidesPerView: 3 },
            }}
          >
            {build_career.map((item, index) => (
              <SwiperSlide key={index}>
                <div className="testimonial_card">
                  <div className="card_content_div">
                    <div className="row">
                      <div className="col-sm-8 order-sm-1 order-2">
                        <div className="card_content">
                          <h5 className="card_heading">{item.title}</h5>
                          <p className="card_text">{item.description}</p>
                        </div>
                      </div>
                      <div className="col-sm-4 order-sm-2 order-1">
                        <div className="img_holder">
                          <img
                            src={`${IDS.IMG_URL}${item.image}`}
                            alt="student"
                            className="card_image"
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="card_footer">
                    <div>
                      <h6 className="student_name">{item.name}</h6>
                      <p className="student_role">{item.designation}</p>
                    </div>
                    <img
                      src={`${IDS.IMG_URL}${item.companylogo}`}
                      alt="company"
                      className="compani_logo"
                    />
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
};

export default Helped_Build;
